import { TextCase } from '../providers';
import { toSentenceCase } from './toSenteceCase';
import { toTitleCase } from './toTitleCase';

export function applyCase(textCase: TextCase, text: string): string {
    switch (textCase) {
        case 'upper':
            return text.toUpperCase();
        case 'sentence':
            return toSentenceCase(text);
        case 'title':
            return toTitleCase(text);
        default:
            return text;
    }
}
